import { r, createSender } from '@/plugins/resource/resource'

const MODEL = 'odoo'

export const odooApi = {
  proxyRequest: r('/proxy-request/', MODEL, createSender),
}
